import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import ocrReducer from './ocrReducer';
import plagiarismReducer from './plagiarismReducer';
import batchOCRReducer from './batchOCRReducer';

// ===========================|| COMBINE REDUCER ||=========================== //

const reducer = combineReducers({
  customization: customizationReducer,
  ocr: ocrReducer,
  plagiarism: plagiarismReducer,
  batchOCR: batchOCRReducer
});

export default reducer;
